import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import axios from "../../api/axios";
import { useDispatch } from "react-redux";
import { asyncCreateModule } from "../../actions/batchApi";
import SmallLoader from "../../utils/SmallLoader";
import { notifyDanger, notifySuccess } from "../../actions/customFn";
import ReactQuill from "react-quill";
import Select from "react-select";


const ScheduleModal = ({
  modalShow,
  setShowModal,
  allBatches,
  isEdit,
  data,
  module_id,
  batch_id,
  updateData,

}) => {
  const [step, setStep] = useState(1);
  const [time, setTime] = useState("");
  const [batchId, setBatchId] = useState("");
  const [moduleId, setModuleId] = useState("");
  const [moduleList, setModuleList] = useState([]);
  const dispatch = useDispatch();
  const [isUpdate, setIsUpdate] = useState(false);
  const [isModuleLoading, setModuleIsLoading] = useState(false);
  const [moduleTitle, setModuleTitle] = useState("");

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");

  const stepOneErr = {};
  const [stepOneErrors, steOneErrors] = useState({});

  const stepTwoErr = {};
  const [stepTwoErrors, setStepTwoErrors] = useState({});

  const [timeInUtc, setTimeInUtc] = useState({
    time: "",
    format: "",
  });

  const [isScheduleLoading, setIsScheduleLoading] = useState(false);

  const modules = {
    toolbar: [
      ["bold", "italic"], // Bold and Italic buttons
      [{ list: "ordered" }, { list: "bullet" }], // Ordered and bullet list
    ],
  };


  const removeBackgroundColor = (content) => {
    return content.replace(/background-color:\s*[^;]+;/gi, "");
  };

  const handleChangeTimeToUtC = (e) => {
    if (e.target.value !== "") {
      setTime(e.target.value);
      const parsedDatetime = moment(e.target.value);
      const utcDatetime = parsedDatetime.utc();
      setTimeInUtc({
        time: utcDatetime.format(),
        format: utcDatetime.format("DD MM  YYYY LT"),
      });
    } else {
      setTime("");
      setTimeInUtc({
        time: "",
        format: "",
      });
    }
  };

  const initialState = () => {
    setShowModal(false);
    setStep(1);
    setModuleId("");
    setBatchId("");
    setTitle("");
    setTime("");
    setDescription("");
    setTimeInUtc({
      time: "",
      format: "",
    });
  };

  useEffect(() => {
    setModuleList([]);
    if (batchId) {
      const url = `/batch/get-batch-byId/${batchId.value}`;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
        },
      };
      axios
        .get(url, config)
        .then((res) => {
          const { data } = res.data;
          setModuleList(data.modules);
        })
        .catch((err) => {
          console.log(err);
          setModuleList([]);
        });
    }
  }, [batchId, isUpdate]);

  const createModule = (e) => {
    const initialState = () => {
      setModuleTitle("");
    };
    e.preventDefault();
    moduleValidation();
    if (Object.keys(stepOneErr).length === 0) {
      setModuleList([]);
      setModuleId("");
      setModuleIsLoading(true);
      const data = {
        id: batchId.value,
        title: moduleTitle,
      };
      dispatch(
        asyncCreateModule(data, setIsUpdate, setModuleIsLoading, initialState)
      );
    }
  };

  const moduleValidation = () => {
    if (batchId.length === 0) {
      stepOneErr.batch = "Please select batch!";
    }
    steOneErrors(stepOneErr);
  };

  const stepOneValidation = () => {
    if (batchId.length === 0) {
      stepOneErr.batch = "Please select batch!";
    }
    if (moduleId.length === 0) {
      stepOneErr.module = "Please select module!";
    }
    steOneErrors(stepOneErr);
  };

  const handleNextStep = () => {
    stepOneValidation();
    if (Object.keys(stepOneErr).length === 0) {
      setStep(2);
    }
  };

  const ScheduleRemainer = () => {
    const data = {
      id: batchId.value,
      title,
      date: timeInUtc.time,
    };
    const url = "/batch/send-schedule-alert";
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };
    axios
      .put(url, data, config)
      .then((res) => {
        const { message } = res.data;
      })
      .catch((err) => {
        console.log(err.response);
        setIsScheduleLoading(false);
        notifyDanger(err.response.message || "Some error Occured");
      });
  };

  const CreateSchedule = () => {
    ScheduleRemainer();
    const cleanDesc = removeBackgroundColor(description)
    const formData = new FormData();
    formData.append("moduleId", moduleId);
    formData.append("title", title);
    formData.append("content", cleanDesc);
    formData.append("isLive", true);
    formData.append("schedule_time", timeInUtc.time);

    const url = "/batch/upload-video";
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };
    axios
      .put(url, formData, config)
      .then((res) => {
        const { message } = res.data;
        notifySuccess(message);
        setIsScheduleLoading(false);
        initialState();
      })
      .catch((err) => {
        console.log(err.response);
        setIsScheduleLoading(false);
        notifyDanger(err.response.message || "Some error Occured");
      });
  };

  const UpdateSchedule = async () => {
    ScheduleRemainer();
    const formData = new FormData();
    formData.append("lessonId", data._id);
    formData.append("title", title);
    formData.append("content", description);
    formData.append("isLive", true);
    formData.append("schedule_time", timeInUtc.time);
    formData.append("moduleId", moduleId);

    const url = "/batch/update-module-video";
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };
    axios
      .put(url, formData, config)
      .then((res) => {
        const { message } = res.data;
        notifySuccess(message);
        setIsScheduleLoading(false);
        initialState();
        updateData((p) => !p);
      })
      .catch((err) => {
        console.log(err);
        setIsScheduleLoading(false);
        notifyDanger(err?.response?.message || "Some error Occured");
      });
  };

  const stepTwoValidation = () => {
    if (title.length === 0) {
      stepTwoErr.title = "Title is required";
    }
    if (time.length === 0) {
      stepTwoErr.time = "Time is required";
    }
    if (description.length === 0) {
      stepTwoErr.description = "Description is required";
    }
    setStepTwoErrors(stepTwoErr);
  };

  const handleSchedule = () => {
    stepTwoValidation();
    if (Object.keys(stepTwoErr).length === 0) {
      setIsScheduleLoading(true);
      if (isEdit) {
        UpdateSchedule();
      } else {
        CreateSchedule();
      }
    }
  };

  useEffect(() => {
    if (isEdit) {
      const existingbatch = allBatches.find((val) => val.value === batch_id)
      setModuleId(module_id);
      setBatchId(existingbatch);
      setTitle(data.title);
      setDescription(data.content);
      const parsedDatetime = moment(data.schedule_time);
      setTime(parsedDatetime.format("YYYY-MM-DDTHH:mm"));
      const utcDatetime = parsedDatetime.utc();
      setTimeInUtc({
        time: utcDatetime.format(),
        format: utcDatetime.format("DD MM  YYYY LT"),
      });
    }
  }, [data, module_id, batch_id]);

  return (
    <Modal
      centered
      className="create-schedule-modal bootstrap-modal-custom"
      show={modalShow}
      onHide={() => setShowModal(false)}
      // style={{ backgroundColor: "#171717" , color: "white" }}
    >
      <Modal.Body style={{ backgroundColor: "#292929" , color: "white" }}>
        <AiOutlineClose
          className="modal-close-btn"
          onClick={() => setShowModal(false)}
        />
        <div className="create-schedule-modal-body" style={{ backgroundColor: "#292929" , color:"white"}}>
          <div className="create-schedule-modal-title">
            <h2> {isEdit ? "Update Schedule" : "Create Schedule"}</h2>
          </div>
          {step === 1 && (
            <>
              <div className="create-schedule-modal-inp">
                <label >Select Active Batch</label>
               <Select
                disabled={isEdit ? true : isModuleLoading}
                options={allBatches}
                onChange={(e) => setBatchId(e)}
                value={batchId}
                classNamePrefix="select"
                placeholder="Select Batch"
                styles={{
                  control: (base) => ({
                    ...base,
                    width: "100%",
                    padding: "5px",
                    borderRadius: "5px",
                    backgroundColor: "#171717",
                    border: "1px solid #10b981",
                    color: "white",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "white",
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: "#171717",
                    color: "white",
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isFocused ? "#10b981" : "#171717",
                    color: "white",
                    cursor: "pointer",
                  }),
                }}
              />
                {stepOneErrors.batch && (
                  <div className="form_error_div">{stepOneErrors.batch}</div>
                )}
              </div>
              <div className="create-schedule-modal-inp">
                <label>Select Module</label>
                <select
                  value={moduleId}
                  disabled={isModuleLoading}
                  onChange={(e) => setModuleId(e.target.value)}
                  style={{width: "100%", padding: "10px 12px", borderRadius: "5px", backgroundColor: "#171717", border: "1px solid #10b981", color: "white"}}
                >
                  <option value={""}>Select Module</option>
                  {moduleList?.length > 0 &&
                    moduleList.map((data, i) => {
                      return <option value={data._id}>{data.title}</option>;
                    })}
                </select>
                {stepOneErrors.module && (
                  <div className="form_error_div">{stepOneErrors.module}</div>
                )}
              </div>
              <div className="create-schedule-modal-or">
                <span></span>
                <b>OR</b>
                <span></span>
              </div>
              <form onSubmit={createModule}>
                <div className="create-schedule-modal-groupinp">
                  <input
                    placeholder="Enter Module Name"
                    type="text"
                    required
                    value={moduleTitle}
                    onChange={(e) => setModuleTitle(e.target.value)}
                  />
                  <button disabled={isModuleLoading} style={{backgroundColor: "#10b981", color: "white"}}>
                    {isModuleLoading ? (
                      <SmallLoader color={"#292929"} />
                    ) : (
                      "Create Module"
                    )}{" "}
                  </button>
                </div>
              </form>

              <div className="create-schedule-modal-submit" >
                <button
                  disabled={isModuleLoading}
                  onClick={() => handleNextStep()}
                  style={{ backgroundColor: "#10b981" , color:"white"}}
                >
                  Next
                </button>
              </div>
            </>
          )}

          {step === 2 && (
            < div style={{backgroundColor: "#292929", padding: "15px", borderRadius: "10px"}}>
              <div className="create-schedule-modal-inp">
                <label>Title of Your Video</label>
                <input
                  disabled={isScheduleLoading}
                  type="text"
                  placeholder="Try Some Relevant Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                {stepTwoErrors.title && (
                  <div className="form_error_div">{stepTwoErrors.title} </div>
                )}
              </div>
              <div style={{color: "white"}} className="create-schedule-modal-inp">
                <label>Description of Your Video</label>
               
                <ReactQuill
                  theme="snow"
                  value={description}
                  onChange={(e) => setDescription(e)}
                  modules={modules}
                />

                {stepTwoErrors.description && (
                  <div className="form_error_div">
                    {stepTwoErrors.description}{" "}
                  </div>
                )}
              </div>
              <div className="create-schedule-modal-inp">
                <label>Enter Schedule time </label>
                <input
                  disabled={isScheduleLoading}
                  type="datetime-local"
                  placeholder="Try Some Relevant Title"
                  value={time}
                  onChange={(e) => {
                    handleChangeTimeToUtC(e);
                  }}
                />
                {stepTwoErrors.time && (
                  <div className="form_error_div">{stepTwoErrors.time} </div>
                )}
              </div>
              {timeInUtc.time !== "" && (
                <h6 className="mt-1 mb-3">
                  Schedule time will be: {timeInUtc.format} (UTC){" "}
                </h6>
              )}
              <div className="create-schedule-modal-submit">
                <button disabled={isScheduleLoading} onClick={() => setStep(1)}>
                  Previous
                </button>
                <button disabled={isScheduleLoading} onClick={handleSchedule}>
                  {isScheduleLoading ? <SmallLoader color={"#292929"} /> : "Done"}
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ScheduleModal;
